export const capitalizeFirstLetter = (string: string): string => string.charAt(0).toUpperCase() + string.slice(1);
export const capitalize = (string: string): string => string.charAt(0).toUpperCase() + string.slice(1);
export const convertToTotalMinutes = (time?: string | null): string => {
	if (!time) {
		return '0:00 min';
	}
	const [hours, minutes, seconds] = time.split(':').map(Number);
	const totalMinutes = hours * 60 + minutes;
	return `${totalMinutes}:${seconds.toString().padStart(2, '0')} min`;
};
